import React from 'react';

const SignatureIcon = ({ color = '#424242', width = 20, height = 21, ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <path d="M3.33203 18.832H16.6654" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M11.5721 3.55374L12.19 2.93582C13.2138 1.91202 14.8737 1.91202 15.8975 2.93582C16.9213 3.95962 16.9213 5.61954 15.8975 6.64334L15.2796 7.26126M11.5721 3.55374C11.5721 3.55374 11.6493 4.86682 12.8079 6.02542C13.9665 7.18402 15.2796 7.26126 15.2796 7.26126M11.5721 3.55374L5.89125 9.23457C5.50647 9.61934 5.31409 9.81173 5.14863 10.0239C4.95345 10.2741 4.78612 10.5448 4.64959 10.8313C4.53385 11.0742 4.44782 11.3323 4.27574 11.8485L3.54657 14.036M15.2796 7.26126L9.59877 12.9421C9.21399 13.3269 9.0216 13.5192 8.80947 13.6847C8.55924 13.8799 8.28849 14.0472 8.00202 14.1837C7.75916 14.2995 7.50105 14.3855 6.98482 14.5576L4.79731 15.2868M4.79731 15.2868L4.26259 15.465C4.00855 15.5497 3.72847 15.4836 3.53912 15.2942C3.34977 15.1049 3.28365 14.8248 3.36833 14.5707L3.54657 14.036M4.79731 15.2868L3.54657 14.036"
        stroke={color}
        strokeWidth="1.25"
      />
    </svg>
  );
};

export default React.forwardRef(SignatureIcon);
